import type { ORPCClientInterceptor } from "@orpc/client";
import { type ClientOperation, clientOperation } from "./client";

export interface TelemetryClientContext {
  operation?: ClientOperation;
}

/** The procedure span includes retries and response decoding; transports receive its explicit context. */
export const traceProcedure: ORPCClientInterceptor<
  TelemetryClientContext,
  unknown,
  unknown,
  Error
> = options => {
  const { path, context, next } = options;
  if (path[0] === "activity") return next();
  return clientOperation(
    path.join("."),
    operation => next({ ...options, context: { ...context, operation } }),
    {},
    context.operation?.context,
  );
};
